<app-leitor-content-panelbusca
  class="leitor-content-panelbusca"
  *ngIf="mostrarPainelBusca"
></app-leitor-content-panelbusca>
<!-- -->
<app-leitor-side-menu
  [ngStyle]="{ visibility: mostrarNovaGuia ? 'hidden' : 'visible' }"
  *ngIf="!(breakpointLg$ | async)"
  class="leitor-content-toolbar"
></app-leitor-side-menu>

<div *ngIf="!mostrarResultadoBuscaAvancada" class="leitor-content-container">
  <app-barra-navegacao
    class="leitor-content-barra-navegacao"
  ></app-barra-navegacao>

  <ng-container *ngIf="!mostrarNovaGuia; else elseNovaGuia">
    <app-pagina class="leitor-content-pagina"></app-pagina>
  </ng-container>
</div>

<ng-container *ngIf="mostrarResultadoBuscaAvancada">
  <app-leitor-content-panelbuscaavancada
    class="leitor-content-busca-avancada"
  ></app-leitor-content-panelbuscaavancada>
</ng-container>

<app-leitor-side-tools
  [ngStyle]="{
    visibility: mostrarNovaGuia ? 'hidden' : 'visible',
    width: mostrarNovaGuia ? '0px' : 'auto'
  }"
  [transition]="mostrarNovaGuia"
  *ngIf="!(breakpointLg$ | async)"
  class="leitor-content-side-tools"
></app-leitor-side-tools>

<app-leitor-side-menu-mobile
  *ngIf="breakpointLg$ | async"
></app-leitor-side-menu-mobile>

<app-leitor-side-tools-mobile
  *ngIf="breakpointLg$ | async"
  class="leitor-side-tools-mobile"
></app-leitor-side-tools-mobile>

<ng-template #elseBuscaAvancada> </ng-template>

<ng-template #elseNovaGuia>
  <div class="leitor-content-nova-guia">
    <div class="leitor-nova-guia-container">
      <div class="leitor-nova-guia-imagem">
        <img class="nova-guia-img" src="assets\ui\nova-guia.png" />
      </div>
      <div class="leitor-nova-guia-titulo-container">
        <div class="leitor-nova-guia-titulo">Olá, estamos melhorando!</div>
      </div>
      <div class="leitor-nova-guia-texto-container">
        <div class="leitor-nova-guia-texto">
          Agora você pode utilizar menu por contexto ou <br />a busca acima para
          encontrar as legislações<br />que desejar!
        </div>
      </div>
    </div>
  </div>
</ng-template>
